import { cardSetConstants, commonConstants } from "../_constants";
import { apiCall } from "../_helpers";
import { appNotification } from "../_components";

const {
  GET_ALL_CARDSETS_START,
  GET_ALL_CARDSETS_SUCCESS,
  GET_ALL_CARDSETS_FAILED,
  ADD_CARDSET_START,
  ADD_CARDSET_END,
  ADD_CARDSET_FAILED,
  VIEW_CARDSET_START,
  VIEW_CARDSET_SUCCESS,
  VIEW_CARDSET_FAILED,
  EDIT_CARDSET_START,
  EDIT_CARDSET_END,
  EDIT_CARDSET_SUCCESS,
  EDIT_CARDSET_FAILED,
} = cardSetConstants;

const { SUCCESSFUL_CODE, GLOBAL_LOADING_START, GLOBAL_LOADING_ENDED } =
  commonConstants;

const TEMP_BASE_URL = "https://automated-terminal-registration.k8.isw.la";

const getAllCardSets = () => {
  return (dispatch) => {
    dispatch({ type: GET_ALL_CARDSETS_START });
    dispatch({ type: GLOBAL_LOADING_START });
    const url = `${TEMP_BASE_URL}/api/v1/cardset/all`;
    apiCall
      .get(url)
      .then((response) => {
        const { message, status, content } = response.data;

        if (status !== SUCCESSFUL_CODE) {
          const error = {
            errorMessage: message,
          };
          dispatch({ type: GET_ALL_CARDSETS_FAILED, payload: error });
          dispatch({ type: GLOBAL_LOADING_ENDED });
          return;
        }
        dispatch({
          type: GET_ALL_CARDSETS_SUCCESS,
          payload: content,
        });
        dispatch({ type: GLOBAL_LOADING_ENDED });
      })
      .catch((error) => {
        const payload = {
          errorMessage: `This was caused by ${error.message} Please try again`,
        };
        dispatch({ type: GET_ALL_CARDSETS_FAILED, payload });
        dispatch({ type: GLOBAL_LOADING_ENDED });
      });
  };
};

const viewCardSet = (id, onSuccessCallback) => {
  return (dispatch) => {
    dispatch({ type: VIEW_CARDSET_START });
    dispatch({ type: GLOBAL_LOADING_START });
    const url = `${TEMP_BASE_URL}/api/v1/cardset/find?code=${id}`;
    apiCall
      .get(url)
      .then((response) => {
        const content = response.data;
        onSuccessCallback();
        dispatch({ type: VIEW_CARDSET_SUCCESS, payload: content });
        dispatch({ type: GLOBAL_LOADING_ENDED });
      })
      .catch((error) => {
        const payload = {
          errorMessage: `This was caused by ${error.message} Please try again`,
        };
        appNotification(
          payload.errorMessage,
          "Unable to get CardSet's Details",
          "error"
        );
        dispatch({ type: VIEW_CARDSET_FAILED, payload });
        dispatch({ type: GLOBAL_LOADING_ENDED });
      });
  };
};

const createCardSet = (data, onSuccessCallback) => {
  return (dispatch) => {
    dispatch({ type: ADD_CARDSET_START });
    dispatch({ type: GLOBAL_LOADING_START });
    const url = `${TEMP_BASE_URL}/api/v1/cardset/create`;
    apiCall
      .post(url, data)
      .then((response) => {
        const { message, status } = response;
        if (status !== 200) {
          const data = response.response.data;
          const error = {
            errorMessage: data[0].message,
          };
          dispatch({ type: ADD_CARDSET_FAILED, payload: error });
          throw new Error(error.errorMessage);
        }

        if (status === 200) {
          const data = response.data;
          const { message, status } = data;
          if (status !== "00") {
            const error = {
              errorMessage: message,
            };
            dispatch({ type: ADD_CARDSET_FAILED, payload: error });
            throw new Error(error.errorMessage);
          } else {
            onSuccessCallback();
            dispatch({ type: EDIT_CARDSET_SUCCESS });
            dispatch({ type: GLOBAL_LOADING_ENDED });
            appNotification(
              "CardSet has been created successfully",
              "CardSet Added",
              "success"
            );
          }
        }
      })
      .catch((error) => {
        const payload = {
          errorMessage: `${error.message}. Please try again`,
        };
        dispatch({ type: ADD_CARDSET_FAILED, payload });
        dispatch({ type: GLOBAL_LOADING_ENDED });
        appNotification(payload.errorMessage, "Unable to add CardSet", "error");
      });
  };
};

const editCardSet = (id, data, onSuccessCallback) => {
  return (dispatch) => {
    dispatch({ type: EDIT_CARDSET_START });
    dispatch({ type: GLOBAL_LOADING_START });
    const url = `${TEMP_BASE_URL}/api/v1/cardset/update/${id}`;
    apiCall
      .put(url, data)
      .then((response) => {
        const { status, message } = response;

        if (status !== 200) {
          const data = response.response.data;
          const error = {
            errorMessage: data[0].message,
          };
          dispatch({ type: EDIT_CARDSET_FAILED, payload: error });
          throw new Error(error.errorMessage);
        }

        if (status === 200) {
          const data = response.data;
          const { message, status } = data;
          if (status !== "00") {
            const error = {
              errorMessage: message,
            };
            dispatch({ type: EDIT_CARDSET_FAILED, payload: error });
            throw new Error(error.errorMessage);
          } else {
            onSuccessCallback();
            dispatch({ type: EDIT_CARDSET_SUCCESS });
            dispatch({ type: GLOBAL_LOADING_ENDED });
            appNotification(
              "CardSet has been updated successfully",
              "CardSet Updated",
              "success"
            );
          }
        }
      })
      .catch((error) => {
        const payload = {
          errorMessage: `${error.message}. Please try again`,
        };
        dispatch({ type: EDIT_CARDSET_FAILED, payload });
        dispatch({ type: GLOBAL_LOADING_ENDED });
        appNotification(
          payload.errorMessage,
          "Unable to update CardSet",
          "error"
        );
      });
  };
};

const cardSetActions = {
  getAllCardSets,
  viewCardSet,
  createCardSet,
  editCardSet,
};

export default cardSetActions;
